<template>
    <div id="loadingMaskBox" class="residence-container container" v-loading="loading" element-loading-background="rgba(255, 255, 255, 0.8)">
        <!-- <div class="residence-nav">
            <span @click="handleToLevel('',-1)">添加建筑：</span>
            <span v-for="(item, index) in residenceBread" 
                :key="index" @click="handleToLevel(item,index)">{{item.name}} <i v-if="index < (residenceBread.length-1)" class="el-icon-arrow-right"></i></span>
        </div> -->
        <div style="margin:10px 0;" class="el-alert el-alert--success">
            <span>当前楼宇位置：</span>
            <span v-if=" projectsystemInfo.project_system_name != '' ">
                {{projectsystemInfo.project_system_name}}
                <i class="el-icon-arrow-right" style="margin:0 4px;"></i>
            </span>
            <template v-for="(v, i) in hBreadcrumb">
                <span class="icon-btn" :key="i" @click="handleClickBread(v, i)">
                    {{v.modulename}}
                    <i class="el-icon-arrow-right" style="margin:0 4px;" v-if="i < hBreadcrumb.length-1"></i>
                </span>
            </template>
        </div>
        <el-row v-if="!isShowRoom" :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" v-has="'house'">
                <div class="add-residence height" @click="handleAddDialog">
                    + 添加{{addForm.typename}}
                </div>
            </el-col>
            <!-- 建筑 -->
            <the-card v-for="v in dataList" :key="v.oid" 
                :buildData="v" 
                @listenEditEvent="listenEditEvent"
                @listenNextEvent="listenNextEvent"
                @listenDeleteEvent="listenDeleteEvent">
            </the-card>
        </el-row>

        <!-- 最后一级房间 -->
        <door-card v-if="isShowRoom" 
            :addForm="addForm"
            :hBreadcrumb="hBreadcrumb"></door-card>

        <!-- 添加建筑弹框 -->
        <cmp-build-form
            @handleCloseDialog="listenDialogClose"
            :visible="visible"
            :addForm="addForm"
            :hBreadcrumb="hBreadcrumb"
        ></cmp-build-form>

        <!-- 编辑建筑弹框 -->
        <el-dialog title="编辑" :visible.sync="dialogEditFormVisible" width="40%">
            <el-form :model="editForm" ref="editForm">
                <el-form-item label="名称" 
                label-width="80px"
                prop="modulename"
                :rules="{
                    required: true, message: '名称不能为空', trigger: 'blur'
                }">
                    <el-input v-model="editForm.modulename" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="备注" label-width="80px">
                    <el-input v-model="editForm.description" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSaveEdit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import CmpBuildForm from './CmpBuildForm/CmpBuildForm'
import TheCard from "./card/TheCard";
import DoorCard from "./doorcard/DoorCard"
import { treeToPath } from '@/utils/array'
import Service from '@/api/Service'
import Storage from '@/utils/storage'
export default {
    name: "AddResidence",
    inject: ['reload'],
    data() {
        return {
            loading: false,
            projectname: '',    //  当前建筑信息
            dataList: [],    //  建筑数组

            tmpDes: [],     //  模型树形结构
            tmpDesArray: [],    // 模型扁平化结构   [{"Typename":"小区","id":0,{"Typename":"楼栋","id":1,"parentId":0,{"Typename":"房间","id":2,"parentId":1}]
            // 添加建筑弹框
            visible: false,
            addForm: {
                typename: '',   //  建筑类型名
                istopmodule: true,    //  是否最顶层
                isendpoint: false,     //  是否最低层
                previous: 0,   //  所属上一层id     默认 0 最上层
                next: '',   //  下一层的类型json:  {"name": "小区","children": { "name": "楼栋" },   // 如果最后一层, 没有children}
            },
            isShowRoom: false,  //  是否显示房间
            nextName: '',
            // 编辑建筑弹框
            dialogEditFormVisible: false,
            editForm: {
                modulename: '',
                description: '',
                oid: '',
            },
			building_index:0,
            hBreadcrumb: [],    //  当前建筑位置
        };
    },
    components: {
        CmpBuildForm,
        TheCard,
        DoorCard
    },
    computed: { 
        // 项目，项目列表
        ...mapGetters(['projectsystemInfo'])
    },
    watch: {
    },
    created() {

    },
    mounted() {
        // 获取项目信息
        this.$store.dispatch("GetProjectInfo").then( res => {
            this.projectname = res.projectname;
            // 获取模型结构
            Service.getTemplate({oid:res.buildings_template_id}).then(ress => {
                this.tmpDes = JSON.parse(ress.description);
                this.tmpDesArray = treeToPath(this.tmpDes)[0];      //  扁平化模型结构
                this.addString = this.tmpDesArray[0].typename;      //  获取顶级typename
                this.getListData(0, this.addString);       //  获取建筑列表
            })
        }).catch(res=>{
			
        })
    },
    methods: {
        // 获取列表
        async getListData(oid, typename) {
            this.loading = true;
            let res = await Service.getBuildList({OID: oid});
            this.loading = false;
            let data = res.list === null ? [] : res.list;
            if(data){
                this.dataList = data
                this.initAddForm(typename);
            }
        },
        // 初始化添加参数
        initAddForm(name) {
            let typename, index, childrenName, istopmodule, isendpoint;
            this.tmpDesArray.map((v, i, item)=>{
                if(v.typename === name){
                    typename = v.typename;
                    index = i;
                    if(i<item.length-1){
                        childrenName = item[i+1].typename;
                    }
                }
            });
            istopmodule = index == 0 ? true : false;
            isendpoint = index == this.tmpDesArray.length - 2;
            this.isShowRoom = index == this.tmpDesArray.length - 1;
            let next = {};
            next.name = typename;
            if(childrenName){
                next.children = {
                    name: childrenName
                }
                this.nextName = childrenName;
            }
            this.addForm = Object.assign(this.addForm, {typename, next:JSON.stringify(next), istopmodule, isendpoint})
        },
        // 添加建筑弹框开启
        handleAddDialog() {
            this.visible = true;
        },
        // 添加建筑弹框关闭
        listenDialogClose(bool) {
            this.visible = false;
            if(bool){
                // 刷新数据
                let {previous, typename} = this.addForm;
                this.getListData(previous, typename)
            }
        },
		fmdata(data){
			return data.reduce((arr, { id, typename, children = [] }) =>
			    arr.concat([{ id, typename }], this.fmdata(children)), [])
		},
        // 编辑建筑
        listenEditEvent(data) {
			console.log(data)
			var arr=[]
			var typename=data.typename
			this.$store.dispatch("GetProjectInfo").then( res => {
			    // 获取模型结构
			    Service.getTemplate({oid:res.buildings_template_id}).then(ress => {
			        arr =this.fmdata(JSON.parse(ress.description));
					let id=arr.filter(v=>{return v.typename == typename})[0].id
					this.building_index= id +1
					this.dialogEditFormVisible = true;
					this.editForm.description = data.description
					this.editForm.oid = data.oid
					this.editForm.modulename = data.modulename;
					this.editForm.building_index = this.building_index;
			    })
			}).catch(res=>{})
			
        },
        // 删除建筑
        listenDeleteEvent() {
            // 刷新数据
            let {previous, typename} = this.addForm;
            this.getListData(previous, typename)
        },
        // 保存编辑
        handleSaveEdit() {
            this.$refs["editForm"].validate(async (valid) => {
                if(valid) {
                    let data = Service.editeBuild(this.editForm);
                    if(data) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!',
                            duration: 1500,
                            onClose: ()=>{
                                // 刷新数据
                                let {previous, typename} = this.addForm;
                                this.getListData(previous, typename)
                            }
                        });
                    }
                    this.dialogEditFormVisible = false;
                }
            })
        },
        // 查看下一级建筑
        listenNextEvent(data) {
            let OID = data.oid;
            let Next = JSON.parse(data.next);
            let typename = Next.children.name;
            this.addForm.previous = OID;    // 保存上层ID
            this.hBreadcrumb.push(data);       // 设置导航缓存
            if(data.isendpoint){
                this.isShowRoom = true
            }else{
                this.getListData(OID, typename);
            }
        },
        // 头部位置
        handleClickBread(v, i) {
            let L = this.hBreadcrumb.length;
            let OID = v.previous;
            let typename = v.typename;
            this.addForm.previous = OID;    // 保存上层ID
            this.getListData(OID, typename);
            this.hBreadcrumb.splice(i, L-i);
        },
    }
};
</script>

<style lang="less" scoped>
.add-residence {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #fff;
    border-radius: 2px;
    border: 1px dashed #d9d9d9;
    color: rgba(0, 0, 0, 0.45);
    cursor: pointer;
}
.add-residence.height {
    height: 188px;
    margin-bottom: 20px;
}
.add-residence:hover {
    box-shadow: none;
    color: @primary-color;
    border: 1px dashed @primary-color;
}
.residence-nav{
    margin: 10px 0;
}
.residence-nav span{
    cursor: pointer;
    margin-right:10px;
}
.residence-nav span:hover{
    color: @primary-color;
}
.residence-nav span:last-child:hover{
     color: #2c3e50;
}
.residence-nav span:last-child{
    cursor: default;
}
</style>
